import { Card, PageHeader, Tabs, Tag } from 'antd'
import User from 'api/User'
import History from 'components/Common/History'
import NewsletterForm from 'components/Main/Newsletter/NewsletterForm'
import UserManagementForm from 'components/Main/UserManagement/ViewUserManagement/UserManagementForm'
import PermissionsContainer from 'components/People/Member/Permissions/PermissionsCont'
import FooterButtons from 'elements/Buttons/FooterButtons'
import RefreshButton from 'elements/Buttons/RefreshButton'
import CustomSpin from 'elements/CustomSpin'
import useModalData from 'elements/Hooks/useModalData'
import React from 'react'
import { withRouter } from 'react-router-dom'

const userApi = new User()

function UserManagementCont(props) {
  const key = props.match.params.key
  const isNew = !key

  const {
    object: data,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    update,
    fetching,
    fetchObject: fetch,
  } = useModalData(
    (data) => userApi.create(data),
    (data) => userApi.updateUser(data),
    userApi.remove,
    undefined,
    key,
    userApi.read,
    (key) => props.history.replace({ pathname: `/users/${key._key}/update` }),
    () => props.history.replace({ pathname: `/users/` })
  )

  return (
    <CustomSpin spinning={fetching}>
      <div className="space-y-2">
        <PageHeader
          ghost={false}
          onBack={() => props.history.push({ pathname: `/users` })}
          title={data?.member?.fn || 'New Profile'}
          tags={<Tag color="blue">{data?.member?.position || 'New'}</Tag>}
          subTitle={data?.username}
          extra={[<RefreshButton onClick={fetch} />]}
        />
        <Card>
          <Tabs defaultActiveKey="details">
            <Tabs.TabPane tab="Details" key="details">
              <UserManagementForm ref={formRef} {...{ data, fetching, isNew }} />
              <FooterButtons
                removing={removing}
                submit={submit}
                update={update}
                submitting={submitting}
                title={'Stock'}
                isNew={isNew}
                isEdit={!isNew}
                // remove={remove}
                // isRemovable={!isNew}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Permissions" key="rules">
              <PermissionsContainer owner={data?.owner} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="History" key="history">
              <History owner={data} key={data._rev} isArray={true} />
            </Tabs.TabPane>
          </Tabs>
        </Card>
      </div>
    </CustomSpin>
  )
}

export default withRouter(UserManagementCont)
